/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_DetailsInputs */

const en_view_details = /** @type {(inputs: View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View details`)
};

const de_view_details = /** @type {(inputs: View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details anzeigen`)
};

/**
* | output |
* | --- |
* | "View details" |
*
* @param {View_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const view_details = /** @type {((inputs?: View_DetailsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_DetailsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_view_details(inputs)
	return en_view_details(inputs)
});